import { useParams } from 'react-router-dom';
import BookingWidget from '../components/booking/BookingWidget';

// Public embeddable booking page, e.g. https://app.strivre.com/book/:booking-slug
export default function PublicBookingPage() {
  const { bookingSlug } = useParams<{ bookingSlug: string }>();

  return (
    <div className="min-h-screen w-full bg-strivre-softgrey flex items-center justify-center p-4 sm:p-8">
      <div className="w-full">
        {/* <div className="text-center mb-6">
          <h1 className="text-xl font-bold text-strivre-navy">Book an Appointment</h1>
          <p className="text-sm text-strivre-mutedtext mt-1">Select a service, date, and time that works for you.</p>
        </div> */}
        {bookingSlug ? <BookingWidget bookingSlug={bookingSlug} /> : <p className="text-center text-strivre-mutedtext">Invalid booking link.</p>}
      </div>
    </div>
  );
}

